import React from 'react';

import { Typography, Card, CardHeader, CardContent } from '@occc-app/design-system';
import { PartialAudienceFragment } from '@occc/graphql';

interface IAudienceDetailsProps {
  audience: PartialAudienceFragment;
}

export const AudienceDetails: React.FC<IAudienceDetailsProps> = ({ audience }) => {
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant='h6' component='h4' gutterBottom>
            {audience.name}
          </Typography>
        }
        subheader={<Typography>{audience.description}</Typography>}
      />
      <CardContent>WIP</CardContent>
    </Card>
  );
};
